import { useSelector } from "react-redux";
import { selectGlobalState } from "../../state-management/selectors";
import backgroundImg from "../../assets/images/areaBack2.svg";
import { AreaChart, Area, XAxis, Tooltip, ResponsiveContainer } from "recharts";
import { getPersianWeekDates } from "../../utils/areaChartData";
import theme from "../../config/theme";

export default function AreaChartComponent() {
  const themeMode = useSelector((state: any) => state.globalState.theme);
  const mode = themeMode === "light" ? theme.light : theme.dark;
  const { newsData, articlesData, projectsData } =
    useSelector(selectGlobalState);

  const color = {
    articleColor: "#8b964a",
    projectColor: "#3e755c",
    newsColor: "#7d807e",
  };

  const data = getPersianWeekDates(articlesData, projectsData, newsData);

  return (
    <div
      className="h-[150px] md:h-[375px]"
      style={{
        background: `url(${backgroundImg})`,
        width: "100%",
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
        borderRadius: "10px",
        padding: "0",
      }}
    >
      <ResponsiveContainer width="100%">
        <AreaChart
          data={data}
          margin={{ top: 30, right: 10, left: 10, bottom: 0 }}
        >
          <defs>
            <linearGradient id="colorUv" x1="0" y1="0" x2="0" y2="1">
              <stop
                offset="5%"
                stopColor={color.articleColor}
                stopOpacity={0.8}
              />
              <stop
                offset="95%"
                stopColor={color.articleColor}
                stopOpacity={0}
              />
            </linearGradient>
            <linearGradient id="colorPv" x1="0" y1="0" x2="0" y2="1">
              <stop
                offset="5%"
                stopColor={color.projectColor}
                stopOpacity={0.8}
              />
              <stop
                offset="95%"
                stopColor={color.projectColor}
                stopOpacity={0}
              />
            </linearGradient>
            <linearGradient id="colorAmt" x1="0" y1="0" x2="0" y2="1">
              <stop offset="5%" stopColor={color.newsColor} stopOpacity={0.8} />
              <stop offset="95%" stopColor={color.newsColor} stopOpacity={0} />
            </linearGradient>
          </defs>
          <XAxis
            dataKey="name"
            tick={{
              fontSize: 12,
              fill: mode.color.textPrimary,
              dy: 5,
              dx: -10,
            }}
          />

          <Tooltip />
          <Area
            type="monotone"
            dataKey="articles"
            stroke={color.articleColor}
            fillOpacity={1}
            strokeWidth={3}
            fill="url(#colorUv)"
          />

          <Area
            type="monotone"
            dataKey="news"
            stroke={color.newsColor}
            strokeWidth={3}
            fillOpacity={1}
            fill="url(#colorAmt)"
          />
        </AreaChart>
      </ResponsiveContainer>
    </div>
  );
}
